import classNames from 'classnames'
import { MouseEventHandler } from 'react'

import { IGNORE_BLUR_CLASS } from 'core-components/library/dropdown/constants'

import styles from './DropdownArrow.module.scss'

interface IDropdownArrow {
  state: 'up' | 'down'
  onMouseDown?: MouseEventHandler<HTMLDivElement>
}
export const DropdownArrow = ({ state, onMouseDown }: IDropdownArrow) => {
  return (
    <div
      className={classNames(styles.arrow, IGNORE_BLUR_CLASS)}
      tabIndex={1}
      data-testid="dropdown__arrow"
      onMouseDown={onMouseDown}
    >
      <i className={`kbase kbase-omni-chevron-${state}`} />
    </div>
  )
}
